<template>
  <div
    class="header-submenu"
    :class="{
      'is-active': visible,
    }"
    @mouseenter="toggleVisible(true)"
    @mouseleave="toggleVisible(false)"
  >
    <div
      class="header-submenu-title"
    >
      <slot
        v-if="$slots.title"
        name="title"
      />
      <span
        v-else
        class="header-submenu-item"
      >
        {{ title }}
        <i class="header-submenu-arrow el-icon-arrow-right" />
      </span>
    </div>
    <transition name="fade">
      <div
        v-show="visible"
        class="header-submenu-container"
        @mouseenter="toggleVisible(true)"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      visibleTimeout: null,
    };
  },
  methods: {
    hide() {
      this.visible = false;
    },
    toggleVisible(visible) {
      clearTimeout(this.visibleTimeout);
      if (!visible) {
        this.visibleTimeout = setTimeout(() => {
          this.visible = visible;
        }, 200);
        return;
      }

      this.visible = visible;
    },
  },
};
</script>

<style>

</style>
